import React, { useState, useCallback } from "react";
import { CircularProgress, Button } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import api from "../api";

const CustomMUIToolbar = ({ tableRef, muiProps }) => {
  const theme = useTheme();

  const [isLoading, setIsLoading] = useState(false);

  const handleStatementsPayment = useCallback(
    (selectedStatementIds) => {
      if (!selectedStatementIds.length) {
        toast.error("Please, select statements to be paid");
        return;
      }

      setIsLoading(true);

      api
        .payStatements({
          statement_ids: selectedStatementIds,
        })
        .then(() => {
          tableRef.current.onAllSelected(false);
          toast.success("Selected statements were paid");
        })
        .catch((err) =>
          toast.error(err.message || "Failed to process payment for selected statements")
        )
        .finally(() => setIsLoading(false));
    },
    [tableRef]
  );

  return (
    <div className="flex items-center justify-between gap-2 !mx-6 !pt-4">
      <Button
        marginLeft={theme.spacing(3)}
        variant="contained"
        color="secondary"
        size="medium"
        onClick={() => {
          tableRef.current.onAllSelected(false);
        }}
      >
        Clear selection
      </Button>

      <div className="flex items-center gap-2">
        <Button
          marginLeft={theme.spacing(3)}
          variant="contained"
          color="primary"
          size="medium"
          disabled={isLoading}
          onClick={() => {
            handleStatementsPayment(muiProps.selectedRows.map(({ id }) => id));
          }}
        >
          Pay for {muiProps.selectedRows.length} statement
          {muiProps.selectedRows.length > 1 ? "s" : ""}
        </Button>
        {isLoading ? <CircularProgress /> : null}
      </div>
    </div>
  );
};

export default CustomMUIToolbar;
